<label>
  <input
    type="checkbox"
    [name]="name"
    [checked]="checked"
    [disabled]="disabled"
    [ngModel]="checked"
    (ngModelChange)="inputOnChange($event)"
  />
  <span><ng-content></ng-content></span>
</label>
